/**
 * vue 插件，用来获取和设置sessioStorage存储
 */
const session = {
  save (key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  },
  fetch (key) {
    return JSON.parse(sessionStorage.getItem(key));
  },
  remove (key) {
    sessionStorage.removeItem(key);
  },
  clear () {
    sessionStorage.clear();
  }
}

export default {
  install (vm) {
    vm.prototype.$session = session;
  }
}


// WEBPACK FOOTER //
// ./src/utils/index.js